import { combineReducers } from 'redux';
import list from './notificationsCenter/list';
import stats from './notificationsCenter/stats';

export default combineReducers({
    list,
    stats,
});



// WEBPACK FOOTER //
// ./src/reducers/app/notificationsCenter.js